import { SaveConfigurationModalButton } from '../save-configuration-modal-button/save-configuration-modal-button';

export type SaveConfigurationButtonProps = {
  onSave: () => Promise<void>;
  isDisabled: boolean;
  isLoading: boolean;
  hasButtonHelpText?: boolean;
  extraContent?: React.ReactNode;
};

export const SaveConfigurationButton = ({
  onSave,
  isDisabled,
  isLoading,
  hasButtonHelpText = false,
  extraContent,
}: SaveConfigurationButtonProps) => {
  return (
    <SaveConfigurationModalButton
      isDisabled={isDisabled}
      isLoading={isLoading}
      onSave={onSave}
      hasButtonHelpText={hasButtonHelpText}
      extraContent={extraContent}
    />
  );
};
